module.exports = __webpack_public_path__ + "static/media/Netflix-TheChefShow-Animated.36a8a484.mp4";